import { makeStyles } from "@material-ui/core";

const tableStyles = makeStyles((theme) => ({
  tableContainer: {
    width: "100%",
  },
  tableHeader: {
    backgroundColor: "#f1f5f9",
    display: "flex",
    padding: "1.25rem 2rem",
    border: "none",
    borderRadius: "1rem 1rem 0 0",
    alignItems: "center",
    fontFamily: "Inter, system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "1.1rem",
    color: "#0a0a29",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    borderBottom: "1px solid #e5e7eb",
  },
  tableBody: {
    padding: "1.25rem 2rem",
    backgroundColor: "#fff",
    borderRadius: "0 0 1rem 1rem",
  },
}));

export default tableStyles;
